import {
	ADD_A_COMMENT,
	ASSIGN_THE_REQUEST,
	CREATE_SERVICE_DESK,
	CREATE_THE_REQUEST,
	INVITE_YOUR_TEAM,
	RESOLVE_THE_REQUEST,
	ADD_A_COMMENT_V2,
	ASSIGN_THE_REQUEST_V2,
	RESOLVE_THE_REQUEST_V2,
	DEFAULT_VERSION,
	LINK_TO_JIRA_SW_ISSUE,
} from '@atlassian/jira-jsd-first-impressions-services/src/constants.tsx';
import type { Task } from './types.tsx';

const versionsTasksMap: {
	[key: string]: Task[];
} = {
	'1': [
		{
			id: ASSIGN_THE_REQUEST,
			completed: false,
		},
		{
			id: ADD_A_COMMENT,
			completed: false,
		},
		{
			id: RESOLVE_THE_REQUEST,
			completed: false,
		},
		{
			id: CREATE_THE_REQUEST,
			completed: false,
		},
		{
			id: INVITE_YOUR_TEAM,
			completed: false,
		},
		{
			id: CREATE_SERVICE_DESK,
			completed: false,
		},
	],
	'2': [
		{
			id: ASSIGN_THE_REQUEST_V2,
			completed: false,
		},
		{
			id: ADD_A_COMMENT_V2,
			completed: false,
		},
		{
			id: RESOLVE_THE_REQUEST_V2,
			completed: false,
		},
		{
			id: CREATE_THE_REQUEST,
			completed: false,
		},
		{
			id: INVITE_YOUR_TEAM,
			completed: false,
		},
		{
			id: CREATE_SERVICE_DESK,
			completed: false,
		},
	],
	'3': [
		{
			id: CREATE_THE_REQUEST,
			completed: false,
		},
		{
			id: ASSIGN_THE_REQUEST_V2,
			completed: false,
		},
		{
			id: LINK_TO_JIRA_SW_ISSUE,
			completed: false,
		},
		{
			id: ADD_A_COMMENT_V2,
			completed: false,
		},
		{
			id: RESOLVE_THE_REQUEST_V2,
			completed: false,
		},
		{
			id: INVITE_YOUR_TEAM,
			completed: false,
		},
		{
			id: CREATE_SERVICE_DESK,
			completed: false,
		},
	],
};

export const getAllTasks: (arg1: { version: number }) => Task[] = ({ version }) =>
	versionsTasksMap[String(version)] || versionsTasksMap[String(DEFAULT_VERSION)];

export const NEXT_UNFINISHED = 'NEXT_UNFINISHED';

export const RIGHT_SIDE_PANEL_ID = 'servicedeskFirstImpressionsRightSidePanel';

export const RIGHT_SIDE_PANEL_WIDTH = 320;

export const TRANSITION_DURATION_MS = 220;
